<template>
  <v-container>
    <div
      style="max-width: 800px; margin: 0 auto; padding: 0 30px 200px;"
    >

      <v-row style="margin-top: 20px;">
        <v-col cols="12" style="font-weight: bold;">
          {{ translate('ui_settings_template_default_settings') }}
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row style="margin-top: 20px;">


        <v-col cols="12" style="display: flex;">
          <div style="width: 50%;">
            {{ translate('ui_settings_template_show_reminder_to_login') }}
          </div>
          <div>

            <v-radio-group
              v-model="$store.state.user.settings.showLoginReminder"
              style="margin-top: 0;"
            >
              <v-radio
                :label="translate('ui_yes')"
                :value="true"
              ></v-radio>
              <v-radio
                :label="translate('ui_no')"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-col>

        <v-col cols="12" style="display: flex;">
          <div style="width: 50%;">
            {{ translate('ui_settings_template_show_onboarding') }}
          </div>
          <div>

            <v-radio-group
              v-model="$store.state.user.settings.showOnboarding"
              style="margin-top: 0;"
            >
              <v-radio
                :label="translate('ui_yes')"
                :value="true"
              ></v-radio>
              <v-radio
                :label="translate('ui_no')"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-col>
      </v-row>

      <div v-if="showAccountSettings">
        <v-row
          style="margin-top: 20px; font-weight: bold;"
        >
          <v-col cols="12">
            {{ translate('ui_settings_account_settings') }}
          </v-col>

        </v-row>
        <v-divider></v-divider>
        <v-row style="margin-top: 20px;">
          <v-col
            v-if="$store.state.user.plan"
            cols="12"
            style="display: flex;"
          >
            <div style="width: 50%;">
              Plan:
            </div>
            <div>
              {{ $store.state.user.plan }}
            </div>
          </v-col>

          <v-col cols="12"
            v-if="$store.state.user.languages.length > 1"
            style="display: flex;"
          >
            <div style="width: 50%;">
              {{ translate('ui_language') }}:
            </div>
            <v-radio-group
              v-model="$store.state.user.settings.language"
              style="margin-top: 0;"
            >
              <v-radio
                v-for="n in $store.state.user.languages"
                :key="n.id"
                :label="n.name"
                :value="n.id"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </div>

      <div v-if="$store.state.loggedin">
        <v-row style="margin-top: 20px;">
          <v-col cols="6">
            <v-text-field
              v-model="$store.state.user.firstName"
              @change="updateUser"
              :label="translate('ui_settings_firstname')"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="$store.state.user.lastName"
              @change="updateUser"
              :label="translate('ui_settings_lastname')"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row style="margin-top: 20px;">
          <v-col cols="6">
            <v-text-field
              v-model="$store.state.user.displayName"
              @change="updateUser"
              :label="translate('ui_settings_displayname')"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row style="margin-top: 20px;">
          <v-col>
            <v-btn @click="logout" outlined>Logout</v-btn>
          </v-col>
        </v-row>
      </div>

    </div>
  </v-container>
</template>

<script>

// mixins
import Mixin from '../mixins/mixin';

export default {
  name: 'Settings',
  mixins: [Mixin],
  computed: {
    showAccountSettings() {
      return this.$store.state.user.plan || this.$store.state.user.languages.length > 1;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
    updateUser() {
      this.$store.dispatch('saveUser');
    },
  },
};

</script>
